<script setup lang="ts">
defineProps<{
  on: boolean
  txt: string | None
}>()
</script>

<template>
  <button type="button" class="_mono _fw-xl _fs09" :class="[$style.btn, on && 'on']">{{ txt }}</button>
</template>

<style module>
.btn {
  composes: global(_h50);
  composes: global(_wmin60);
  composes: global(_bg0);
  composes: global(_ctr);
  composes: global(_br14);

  margin-right: -1px;

  composes: global(_pt04);
  composes: global(_pb04);
  composes: global(_pl04);
  composes: global(_pr04);

  border: 1px solid var(--black-2);
}
.btn:global(.on),
.btn:hover {
  z-index: 1;
  color: var(--bg);
  background: var(--blue3);
  border-color: var(--blue3);
}
</style>
